<nb-card class="infopalet-card">
  <nb-card-header>
    Detalle del Palet
  </nb-card-header>

  <nb-card-body class="infopalet-body">
    <ng-container *ngIf="palets && palets.length > 1">
      <div class="tabla-wrapper" style="margin-bottom: 14px;">
        <div class="multi-resultados-header">
          <div class="multi-resultados-titulo">Resultados encontrados: {{ palets.length }}</div>
          <div class="multi-resultados-subtitulo">Seleccione un palet para desplegar su detalle completo.</div>
        </div>
        <table class="vertical-table mat-elevation-z1 styled-table multi-resultados-table">
          <tr class="multi-resultados-head-row">
            <th>ID Palet</th>
            <th>Lote</th>
            <th>Producto</th>
            <th>Ubicación</th>
            <th class="acciones-columna">Acciones</th>
          </tr>
          <ng-container *ngFor="let resultado of palets">
            <tr class="resultado-row" [class.resultado-row-expanded]="isSelectedPalet(resultado)">
              <td class="resultado-id">{{ resultado.idpalet }}</td>
              <td>{{ resultado.lote_aliquo || '-' }}</td>
              <td>
                <div>{{ resultado.producto }}</div>
                <div class="subdato" *ngIf="resultado.calibre">Calibre {{ resultado.calibre }}</div>
              </td>
              <td>
                <div>{{ resultado.ubicacion }}</div>
                <div class="subdato" *ngIf="resultado.hueco">{{ getHuecoTexto(resultado) }}</div>
              </td>
              <td class="resultado-acciones">
                <button nbButton size="tiny" status="primary" (click)="seleccionarPalet(resultado)">
                  <nb-icon [icon]="isSelectedPalet(resultado) ? 'arrow-up-outline' : 'eye-outline'"></nb-icon>
                  {{ isSelectedPalet(resultado) ? 'Ocultar' : 'Ver' }}
                </button>
                <button nbButton size="tiny" status="info" (click)="onPrintEtiquetaInterna(resultado)" style="margin-left: 6px;">
                  <nb-icon icon="printer-outline"></nb-icon>
                  Etiqueta
                </button>
              </td>
            </tr>
            <tr *ngIf="isSelectedPalet(resultado)">
              <td colspan="5" class="expanded-detail-cell">
              <div class="detalle-inline">
                <div class="detalle-inline-header">
                  <div class="detalle-inline-title">
                    Detalle del palet {{ palet.idpalet }}
                  </div>
                  <div>
                    <button nbButton size="tiny" status="info" (click)="onPrintEtiquetaInterna(palet)">
                      <nb-icon icon="printer-outline"></nb-icon>
                      Imprimir etiqueta interna
                    </button>
                    <button *ngIf="canEditPaletData && !isEditingPaletData" nbButton size="tiny" status="primary" (click)="startEditPaletData()" style="margin-left: 6px;">
                      <nb-icon icon="edit-outline"></nb-icon>
                      Editar datos
                    </button>
                    <button *ngIf="canEditPaletData && isEditingPaletData" nbButton size="tiny" status="success" (click)="saveEditPaletData()" style="margin-left: 6px;">
                      <nb-icon icon="checkmark-outline"></nb-icon>
                      Guardar
                    </button>
                    <button *ngIf="canEditPaletData && isEditingPaletData" nbButton size="tiny" status="basic" (click)="cancelEditPaletData()" style="margin-left: 6px;">
                      <nb-icon icon="close-outline"></nb-icon>
                      Cancelar
                    </button>
                  </div>
                </div>
              <table class="vertical-table mat-elevation-z1 styled-table detalle-card" style="margin-bottom: 12px;">
                <tr>
                  <th>Ubicación</th>
                  <td>{{ palet.ubicacion }}</td>
                </tr>
                <tr>
                  <th>Hueco (profundidad)</th>
                  <td>{{ getHuecoTexto(palet) }}</td>
                </tr>
                <tr>
                  <th>ID Palet</th>
                  <td>{{ palet.idpalet }}</td>
                </tr>
                <tr *ngIf="palet.tipo === 4 && palet.idpalet_origen">
                  <th>Palet origen</th>
                  <td>
                    {{ palet.idpalet_origen }}
                    <button nbButton size="tiny" status="info" (click)="openRelatedPalet(palet.idpalet_origen)" style="margin-left: 6px;">Ver origen</button>
                  </td>
                </tr>
                <tr *ngIf="palet.tipo === 4 && palet.idpedido_transformacion">
                  <th>Pedido transformación</th>
                  <td>{{ palet.idpedido_transformacion }}</td>
                </tr>
                <tr *ngIf="palet.tipo === 4 && palet.idlinea_pedido_transformacion">
                  <th>Línea pedido transformación</th>
                  <td>{{ palet.idlinea_pedido_transformacion }}</td>
                </tr>
                <tr>
                  <th>Código Aliquo (lote_aliquo)</th>
                  <td>{{ palet.lote_aliquo }}</td>
                </tr>
                <tr>
                  <th>Referencia Aliquo (reference)</th>
                  <td>{{ palet.reference }}</td>
                </tr>
                <tr>
                  <th>Producto</th>
                  <td>
                    <ng-container *ngIf="isEditingPaletData && canEditPaletData; else productoInlineView">
                      <mat-form-field appearance="fill" style="width: 100%;">
                        <mat-select [(ngModel)]="editPaletDraft.producto">
                          <mat-option [value]="null">Sin producto</mat-option>
                          <mat-option *ngFor="let producto of productos" [value]="producto">{{ producto.nombre }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-container>
                    <ng-template #productoInlineView>{{ palet.producto }}</ng-template>
                  </td>
                </tr>
                <tr>
                  <th>Calidad</th>
                  <td>
                    <ng-container *ngIf="isEditingPaletData && canEditPaletData; else calidadInlineView">
                      <mat-form-field appearance="fill" style="width: 100%;">
                        <mat-select [(ngModel)]="editPaletDraft.codigo_caja">
                          <mat-option [value]="null">Sin calidad</mat-option>
                          <mat-option *ngFor="let tipoCaja of tiposCaja" [value]="tipoCaja">
                            {{ tipoCaja.codigo }}<ng-container *ngIf="tipoCaja.codigo && tipoCaja.nombre"> - </ng-container>{{ tipoCaja.nombre }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-container>
                    <ng-template #calidadInlineView>
                      <ng-container *ngIf="palet.tipo_caja_codigo || palet.tipo_caja_nombre; else sinTipoCajaInline">
                        {{ palet.tipo_caja_codigo }}<ng-container *ngIf="palet.tipo_caja_codigo && palet.tipo_caja_nombre"> - </ng-container>{{ palet.tipo_caja_nombre }}
                        <span *ngIf="palet.tipo_cajas">(id: {{ palet.tipo_cajas }})</span>
                      </ng-container>
                      <ng-template #sinTipoCajaInline>
                        <span *ngIf="palet.tipo_cajas">(id: {{ palet.tipo_cajas }})</span>
                        <span *ngIf="!palet.tipo_cajas">Sin calidad</span>
                      </ng-template>
                    </ng-template>
                  </td>
                </tr>
                <tr>
                  <th>Calibre</th>
                  <td>{{ palet.calibre }}</td>
                </tr>
                <tr>
                  <th>Proveedor</th>
                  <td>{{ palet.proveedor }}</td>
                </tr>
                <tr>
                  <th>Número de Cajas</th>
                  <td>
                    <ng-container *ngIf="isEditingPaletData && canEditPaletData; else cajasInlineView">
                      <input type="number" min="0" [(ngModel)]="editPaletDraft.n_cajas_entrada" style="width: 120px;">
                    </ng-container>
                    <ng-template #cajasInlineView>{{ palet.n_cajas_entrada ?? palet.n_cajas }}</ng-template>
                  </td>
                </tr>
                <tr>
                  <th>Stock de Cajas</th>
                  <td>
                    <ng-container *ngIf="isEditingPaletData && canEditPaletData; else stockInlineView">
                      <input type="number" min="0" [(ngModel)]="editPaletDraft.stock_cajas" style="width: 120px;">
                    </ng-container>
                    <ng-template #stockInlineView>{{ palet.stock_cajas }}</ng-template>
                  </td>
                </tr>
                <tr>
                  <th>Peso Bruto</th>
                  <td>{{ palet.peso_bruto }} kg</td>
                </tr>
                <tr>
                  <th>Peso Neto</th>
                  <td>{{ palet.peso_neto }} kg</td>
                </tr>
                <tr>
                  <th>Peso Tara</th>
                  <td>{{ palet.peso_tara }} kg</td>
                </tr>
                <tr>
                  <th>ID Entrada</th>
                  <td>{{ palet.identrada }}</td>
                </tr>
                <tr>
                  <th>Estado</th>
                  <td>
                    <ng-container *ngIf="isEditingPaletData && canEditPaletData; else estadoInlineView">
                      <select [(ngModel)]="editPaletDraft.estado" style="width: 220px; height: 36px; border: 1px solid #c5cee0; border-radius: 4px; padding: 0 10px; background: #fff;">
                        <option *ngFor="let estado of estadoOptions" [ngValue]="estado.value">{{ estado.label }}</option>
                      </select>
                    </ng-container>
                    <ng-template #estadoInlineView>{{ getEstadoTexto() }}</ng-template>
                  </td>
                </tr>
                <tr>
                  <th>Fecha Entrada</th>
                  <td>{{ palet.fechaentrada | date: 'dd-MM-yyyy' }}</td>
                </tr>
                <tr>
                  <th>Semana carga</th>
                  <td>{{ palet.sem_carga || '-' }}</td>
                </tr>
                <tr>
                  <th>Fecha Salida</th>
                  <td>{{ palet.fechasalida | date: 'dd-MM-yyyy' }}</td>
                </tr>
                <tr>
                  <th>Fecha creación</th>
                  <td>{{ palet.fecha_creacion | date: 'dd-MM-yyyy HH:mm' }}</td>
                </tr>
                <tr>
                  <th>Fecha último movimiento</th>
                  <td>{{ palet.fecha_almac | date: 'dd-MM-yyyy HH:mm' }}</td>
                </tr>

                <tr *ngIf="transformacionInfo">
                  <th>Transformación</th>
                  <td>
                    <div><strong>Rol:</strong> {{ transformacionInfo.rol === 'resultado' ? 'Palet resultado' : 'Palet origen' }}</div>
                    <div><strong>Partida:</strong> {{ transformacionInfo.idpartida_transformacion || '-' }}</div>
                    <div><strong>Pedido transformación:</strong> {{ transformacionInfo.idpedido_transformacion || '-' }}</div>
                    <div><strong>Venta:</strong> {{ transformacionInfo.idventa || '-' }}</div>
                    <div><strong>Cliente:</strong> {{ transformacionInfo.cliente || '-' }}</div>
                    <div><strong>Fecha prevista:</strong> {{ transformacionInfo.fecha_prevista || '-' }}</div>
                    <div><strong>Estado partida:</strong> {{ getEstadoPartidaTransformacionTexto(transformacionInfo.estado_partida) }}</div>
                    <div style="margin: 8px 0 10px;">
                      <button nbButton size="tiny" status="primary" (click)="openTransformacionPartida()">
                        <nb-icon icon="external-link-outline"></nb-icon>
                        Abrir partida
                      </button>
                      <button nbButton size="tiny" status="info" style="margin-left: 8px;" *ngIf="transformacionInfo.idpedido_transformacion" (click)="openTransformacionPedido()">
                        <nb-icon icon="layers-outline"></nb-icon>
                        Abrir pedido
                      </button>
                    </div>
                    <div *ngIf="transformacionInfo.rol === 'resultado'">
                      <strong>Palets origen:</strong>
                      <div *ngIf="transformacionInfo.origenes?.length; else sinOrigenesTransformacion">
                        <div *ngFor="let origen of transformacionInfo.origenes" class="subdato" style="margin-top: 4px; display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                          <span>{{ origen.lote_aliquo || origen.idpalet }} · {{ origen.producto || '-' }} · {{ origen.cantidad || 0 }}</span>
                          <button nbButton size="tiny" status="info" (click)="openRelatedPalet(origen.idpalet, origen.lote_aliquo)">
                            <nb-icon icon="eye-outline"></nb-icon>
                            Ver palet
                          </button>
                        </div>
                      </div>
                      <ng-template #sinOrigenesTransformacion>
                        <span class="subdato">Sin palets origen registrados.</span>
                      </ng-template>
                    </div>
                    <div *ngIf="transformacionInfo.rol === 'origen'">
                      <strong>Palets resultado:</strong>
                      <div *ngIf="transformacionInfo.resultados?.length; else sinResultadosTransformacion">
                        <div *ngFor="let resultado of transformacionInfo.resultados" class="subdato" style="margin-top: 4px; display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                          <span>{{ resultado.lote_aliquo || resultado.idpalet }} · {{ resultado.producto || '-' }} · {{ resultado.cantidad || 0 }}</span>
                          <button nbButton size="tiny" status="info" (click)="openRelatedPalet(resultado.idpalet, resultado.lote_aliquo)">
                            <nb-icon icon="eye-outline"></nb-icon>
                            Ver palet
                          </button>
                        </div>
                      </div>
                      <ng-template #sinResultadosTransformacion>
                        <span class="subdato">Sin palets resultado registrados.</span>
                      </ng-template>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>Anotaciones</th>
                  <td>
                    <div *ngIf="!isEditingAnotaciones">
                      <span *ngIf="anotaciones">{{ anotaciones }}</span>
                      <span *ngIf="!anotaciones" style="color: #999; font-style: italic;">Sin anotaciones</span>
                      <button nbButton size="tiny" status="info" (click)="editAnotaciones()" style="margin-left: 10px;">
                        <nb-icon icon="edit-outline"></nb-icon> Editar
                      </button>
                    </div>
                    <div *ngIf="isEditingAnotaciones">
                      <textarea [(ngModel)]="anotaciones" rows="3" style="width: 100%; resize: vertical;"></textarea>
                      <div *ngIf="interimText" style="color: #999; font-style: italic; margin-top: 5px;">
                        {{ interimText }}
                      </div>
                      <div *ngIf="errorMessage" style="color: red; margin-top: 5px;">
                        {{ errorMessage }}
                      </div>
                      <div style="margin-top: 5px;">
                        <button nbButton size="small" status="success" (click)="saveAnotaciones()">
                          <nb-icon icon="checkmark-outline"></nb-icon> Guardar
                        </button>
                        <button nbButton size="small" status="basic" (click)="cancelAnotaciones()" style="margin-left: 5px;">
                          <nb-icon icon="close-outline"></nb-icon> Cancelar
                        </button>
                        <button
                          nbButton
                          size="small"
                          [status]="isListening ? 'danger' : 'info'"
                          (click)="isListening ? stopListening() : startListening()"
                          style="margin-left: 5px;">
                          <nb-icon [icon]="isListening ? 'stop-circle-outline' : 'mic-outline'"></nb-icon>
                          {{ isListening ? 'Detener' : 'Dictar' }}
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>

              <div class="detalle-section-title">Histórico de salidas</div>
              <table class="vertical-table mat-elevation-z1 styled-table detalle-card" *ngIf="picking && picking.length; else sinPickingInline" style="margin-bottom: 12px;">
                <tr *ngFor="let pick of picking">
                  <th>Cajas:</th>
                  <td>{{ pick.unidades }}</td>
                  <th>Cuando:</th>
                  <td>{{ pick.realizado }}</td>
                  <th>ID Salida:</th>
                  <td>{{ pick.idsalida }}</td>
                </tr>
              </table>
              <ng-template #sinPickingInline>
                <div class="detalle-empty" style="margin-bottom: 12px;">Sin histórico de salidas para este palet.</div>
              </ng-template>

              <div class="detalle-section-title">Histórico de movimientos</div>
              <table class="vertical-table mat-elevation-z1 styled-table detalle-card" *ngIf="movimientos && movimientos.length; else sinMovimientosInline">
                <tr *ngFor="let movimiento of movimientos">
                  <th>Fecha:</th>
                  <td>{{ movimiento.fecha }}</td>
                  <th>Origen:</th>
                  <td>{{ movimiento.ubicacion_inicial }}</td>
                  <th>Destino:</th>
                  <td>{{ movimiento.ubicacion_final }}</td>
                </tr>
              </table>
              <ng-template #sinMovimientosInline>
                <div class="detalle-empty">Sin histórico de movimientos para este palet.</div>
              </ng-template>
              </div>
              </td>
            </tr>
          </ng-container>
        </table>
        <div class="detalle-empty" *ngIf="!palet">Ningún palet desplegado.</div>
      </div>
    </ng-container>

    <ng-container *ngIf="palet && !(palets && palets.length > 1); else cargandoPalet">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
        <div style="font-weight: 600;">
          Detalle del palet {{ palet.idpalet }}
        </div>
        <div>
          <button nbButton size="tiny" status="info" (click)="onPrintEtiquetaInterna(palet)">
            Imprimir etiqueta interna
          </button>
          <button *ngIf="canEditPaletData && !isEditingPaletData" nbButton size="tiny" status="primary" (click)="startEditPaletData()" style="margin-left: 6px;">
            Editar datos
          </button>
          <button *ngIf="canEditPaletData && isEditingPaletData" nbButton size="tiny" status="success" (click)="saveEditPaletData()" style="margin-left: 6px;">
            Guardar
          </button>
          <button *ngIf="canEditPaletData && isEditingPaletData" nbButton size="tiny" status="basic" (click)="cancelEditPaletData()" style="margin-left: 6px;">
            Cancelar
          </button>
        </div>
      </div>
      <table class="vertical-table mat-elevation-z8 styled-table">
        <tr>
          <th>Ubicación</th>
          <td>{{ palet.ubicacion }}</td>
        </tr>
        <tr>
          <th>Hueco (profundidad)</th>
          <td>{{ getHuecoTexto(palet) }}</td>
        </tr>
        <tr>
          <th>ID Palet</th>
          <td>{{ palet.idpalet }}</td>
        </tr>
        <tr>
          <th>Código Aliquo (lote_aliquo)</th>
          <td>{{ palet.lote_aliquo }}</td>
        </tr>
        <tr>
          <th>Referencia Aliquo (reference)</th>
          <td>{{ palet.reference }}</td>
        </tr>
        <tr>
          <th>Producto</th>
          <td>
            <ng-container *ngIf="isEditingPaletData && canEditPaletData; else productoSimpleView">
              <mat-form-field appearance="fill" style="width: 100%;">
                <mat-select [(ngModel)]="editPaletDraft.producto">
                  <mat-option [value]="null">Sin producto</mat-option>
                  <mat-option *ngFor="let producto of productos" [value]="producto">{{ producto.nombre }}</mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
            <ng-template #productoSimpleView>{{ palet.producto }}</ng-template>
          </td>
        </tr>
        <tr>
          <th>Calidad</th>
          <td>
            <ng-container *ngIf="isEditingPaletData && canEditPaletData; else calidadSimpleView">
              <mat-form-field appearance="fill" style="width: 100%;">
                <mat-select [(ngModel)]="editPaletDraft.codigo_caja">
                  <mat-option [value]="null">Sin calidad</mat-option>
                  <mat-option *ngFor="let tipoCaja of tiposCaja" [value]="tipoCaja">
                    {{ tipoCaja.codigo }}<ng-container *ngIf="tipoCaja.codigo && tipoCaja.nombre"> - </ng-container>{{ tipoCaja.nombre }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
            <ng-template #calidadSimpleView>
              <ng-container *ngIf="palet.tipo_caja_codigo || palet.tipo_caja_nombre; else sinTipoCaja">
                {{ palet.tipo_caja_codigo }}<ng-container *ngIf="palet.tipo_caja_codigo && palet.tipo_caja_nombre"> - </ng-container>{{ palet.tipo_caja_nombre }}
                <span *ngIf="palet.tipo_cajas">(id: {{ palet.tipo_cajas }})</span>
              </ng-container>
              <ng-template #sinTipoCaja>
                <span *ngIf="palet.tipo_cajas">(id: {{ palet.tipo_cajas }})</span>
                <span *ngIf="!palet.tipo_cajas">Sin calidad</span>
              </ng-template>
            </ng-template>
          </td>
        </tr>
        <tr>
          <th>Calibre</th>
          <td>{{ palet.calibre }}</td>
        </tr>
        <tr>
          <th>Proveedor</th>
          <td>{{ palet.proveedor }}</td>
        </tr>
        <tr>
          <th>Número de Cajas</th>
          <td>{{ palet.n_cajas }}</td>
        </tr>
        <tr>
          <th>Número de Cajas Entrada</th>
          <td>
            <ng-container *ngIf="isEditingPaletData && canEditPaletData; else cajasEntradaSimpleView">
              <input type="number" min="0" [(ngModel)]="editPaletDraft.n_cajas_entrada" style="width: 120px;">
            </ng-container>
            <ng-template #cajasEntradaSimpleView>{{ palet.n_cajas_entrada }}</ng-template>
          </td>
        </tr>
        <tr>
          <th>Stock de Cajas</th>
          <td>
            <ng-container *ngIf="isEditingPaletData && canEditPaletData; else stockSimpleView">
              <input type="number" min="0" [(ngModel)]="editPaletDraft.stock_cajas" style="width: 120px;">
            </ng-container>
            <ng-template #stockSimpleView>{{ palet.stock_cajas }}</ng-template>
          </td>
        </tr>
        <tr>
          <th>Peso Bruto</th>
          <td>{{ palet.peso_bruto }} kg</td>
        </tr>
        <tr>
          <th>Peso Neto</th>
          <td>{{ palet.peso_neto }} kg</td>
        </tr>
        <tr>
          <th>Peso Tara</th>
          <td>{{ palet.peso_tara }} kg</td>
        </tr>
        <tr>
          <th>ID Entrada</th>
          <td>{{ palet.identrada }}</td>
        </tr>
        <tr>
          <th>Estado</th>
          <td>
            <ng-container *ngIf="isEditingPaletData && canEditPaletData; else estadoSimpleView">
              <select [(ngModel)]="editPaletDraft.estado" style="width: 220px; height: 36px; border: 1px solid #c5cee0; border-radius: 4px; padding: 0 10px; background: #fff;">
                <option *ngFor="let estado of estadoOptions" [ngValue]="estado.value">{{ estado.label }}</option>
              </select>
            </ng-container>
            <ng-template #estadoSimpleView>{{ getEstadoTexto() }}</ng-template>
          </td>
        </tr>
        <tr>
          <th>Fecha Entrada</th>
          <td>{{ palet.fechaentrada | date: 'dd-MM-yyyy' }}</td>
        </tr>
        <tr>
          <th>Semana carga</th>
          <td>{{ palet.sem_carga || '-' }}</td>
        </tr>
        <tr>
          <th>Fecha Salida</th>
          <td>{{ palet.fechasalida | date: 'dd-MM-yyyy' }}</td>
        </tr>
        <tr>
          <th>Fecha creación</th>
          <td>{{ palet.fecha_creacion | date: 'dd-MM-yyyy HH:mm' }}</td>
        </tr>
        <tr>
          <th>Fecha último movimiento</th>
          <td>{{ palet.fecha_almac | date: 'dd-MM-yyyy HH:mm' }}</td>
        </tr>
        <tr>
          <th>Anotaciones</th>
          <td>
            <div *ngIf="!isEditingAnotaciones">
              <span *ngIf="anotaciones">{{ anotaciones }}</span>
              <span *ngIf="!anotaciones" style="color: #999; font-style: italic;">Sin anotaciones</span>
              <button nbButton size="tiny" status="info" (click)="editAnotaciones()" style="margin-left: 10px;">
                <nb-icon icon="edit-outline"></nb-icon> Editar
              </button>
            </div>
            <div *ngIf="isEditingAnotaciones">
              <textarea [(ngModel)]="anotaciones" rows="3" style="width: 100%; resize: vertical;"></textarea>
              <div *ngIf="interimText" style="color: #999; font-style: italic; margin-top: 5px;">
                {{ interimText }}
              </div>
              <div *ngIf="errorMessage" style="color: red; margin-top: 5px;">
                {{ errorMessage }}
              </div>
              <div style="margin-top: 5px;">
                <button nbButton size="small" status="success" (click)="saveAnotaciones()">
                  <nb-icon icon="checkmark-outline"></nb-icon> Guardar
                </button>
                <button nbButton size="small" status="basic" (click)="cancelAnotaciones()" style="margin-left: 5px;">
                  <nb-icon icon="close-outline"></nb-icon> Cancelar
                </button>
                <button
                  nbButton
                  size="small"
                  [status]="isListening ? 'danger' : 'info'"
                  (click)="isListening ? stopListening() : startListening()"
                  style="margin-left: 5px;">
                  <nb-icon [icon]="isListening ? 'stop-circle-outline' : 'mic-outline'"></nb-icon>
                  {{ isListening ? 'Detener' : 'Dictar' }}
                </button>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </ng-container>
    <ng-template #cargandoPalet>
      <div *ngIf="!(palets && palets.length > 1)">Cargando información de palet...</div>
    </ng-template>
  </nb-card-body>

  <nb-card-body *ngIf="!(palets && palets.length > 1)">
    <table class="vertical-table mat-elevation-z8 styled-table" *ngIf="picking && picking.length; else sinPicking">
      <tr *ngFor="let pick of picking">
        <th>Cajas:</th>
        <td>{{ pick.unidades }}</td>
        <th>Cuando:</th>
        <td>{{ pick.realizado }}</td>
        <th>ID Salida:</th>
        <td>{{ pick.idsalida }}</td>
      </tr>
    </table>
    <ng-template #sinPicking>
      <div>Sin histórico de salidas para este palet.</div>
    </ng-template>
  </nb-card-body>

  <nb-card-body *ngIf="!(palets && palets.length > 1)">
    <table class="vertical-table mat-elevation-z8 styled-table" *ngIf="movimientos && movimientos.length; else sinMovimientos">
      <tr *ngFor="let movimiento of movimientos">
        <th>Fecha:</th>
        <td>{{ movimiento.fecha }}</td>
        <th>Origen:</th>
        <td>{{ movimiento.ubicacion_inicial }}</td>
        <th>Destino:</th>
        <td>{{ movimiento.ubicacion_final }}</td>
      </tr>
    </table>
    <ng-template #sinMovimientos>
      <div>Sin histórico de movimientos para este palet.</div>
    </ng-template>
  </nb-card-body>

  <nb-card-footer>
    <button nbButton (click)="ref.close()">Cerrar</button>
  </nb-card-footer>
</nb-card>
